
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const DonatePage = lazy(() => import('../pages/donate/page'));
const BooksPage = lazy(() => import('../pages/books/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/donate',
    element: <DonatePage />,
  },
  {
    path: '/books',
    element: <BooksPage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
